/* eslint-disable react-hooks/exhaustive-deps */
import ICONS from "../../../../../assets/Icons";
import formatCurrency from "../../../../../utils/CurrencyFormater";
import SVGComponent from "../../../../_utils/SVGComponent";
import DataActionField from "../../../../_utils/TransactionCommonComponents/DataActionField";

const InternalRecreateTxnStepAmountPaymentMethod = ({
  refactorTransactionData,
  setTxnPayLoad,
  refactorCopyAmount,
  setRefactorCopyAmount,
  COPY_KEYS,
  refactorPaymentMethod,
  setIsNeft,
  setIsRtgs,
  setAutoFill,
  setCopyData,
}) => {
  return (
    <main className="flex flex-col lg:flex-row gap-gap-md lg:gap-gap-xl Qsmd:my-margin-md h-screen Qsmd:h-auto bg-primary-bg Qsmd:bg-primary-card w-width-full fixed Qsmd:z-z-index-content z-z-index-overlay Qsmd:relative top-top-base left-left-base mt-margin-base">
      <div className="h-mobile-create-header flex w-width-full bg-primary-nav Qsmd:hidden">
        <div className="p-padding-md Qsmd:p-padding-base">
          <div
            className="flex flex-shrink-0 cursor-pointer"
            onClick={() => {
              setAutoFill(false);
            }}
          >
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color="var(--text-primary)"
              height={"var(--icon-md)"}
              width={"var(--icon-md)"}
              alt="Arrow right"
            />
          </div>
        </div>
        <div className="flex flex-col w-width-full py-padding-sm">
          <div className="text-text-primary text-font-md">
            Create transaction
          </div>
          <p className=" text-text-primary text-xs font-semibold">
            Previous transaction details
          </p>
        </div>
      </div>

      <section className="flex flex-col gap-gap-md lg:flex-1 w-width-full h-auto px-padding-md Qsmd:px-padding-base">
        <DataActionField
          label="Transfer Amount"
          value={`INR ${formatCurrency(Number(refactorTransactionData?.amount))}`}
          icon={
            refactorCopyAmount ? ICONS?.SELECTED_WITH_GREEN_CIRCLE : ICONS?.COPY
          }
          hoverEnabled={!refactorCopyAmount}
          onClick={() => {
            if (refactorCopyAmount) return;
            const amt = Number(refactorTransactionData?.amount);
            setRefactorCopyAmount(true);
            setCopyData({
              title: COPY_KEYS.AMOUNT,
              data_type: "numeric",
              value: amt,
            });
          }}
        />
      </section>

      <section className="flex flex-col gap-gap-md lg:flex-1 w-width-full h-auto px-padding-md Qsmd:px-padding-base">
        <DataActionField
          label="Select Payment Method"
          value={refactorTransactionData?.payment_method?.toUpperCase() ?? ""}
          icon={
            refactorPaymentMethod
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          onClick={() => {
            if (refactorPaymentMethod) return;
            const prevMethod =
              refactorTransactionData?.payment_method?.toUpperCase();
            setIsNeft(prevMethod === "NEFT");
            setIsRtgs(prevMethod === "RTGS");
            setTxnPayLoad((prev) => ({
              ...prev,
              settleType: prevMethod?.toLowerCase(),
            }));
          }}
        />
      </section>
    </main>
  );
};

export default InternalRecreateTxnStepAmountPaymentMethod;
